<template>
  <div class="container contact">
    <div class="row">
      <div class="col-md-12">
        <p>Schreib uns auf <a href="https://twitter.com/radfahrerwissen" target="_blank">Twitter</a></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact'
}
</script>
<!-- styling for the component -->
<style>
.contact {
  text-align: center;
  font-size: 18px;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue